
import Cookies from 'js-cookie';

export default () => {
    //Popup Member
    let popup_newsletter = document.querySelector('.js-popup-newsletter');
    let read_cookie = Cookies.get('lycia-newsletter-cookie');
    if (popup_newsletter) {
        if (!read_cookie) {
            setTimeout(() => {
                popup_newsletter.classList.add('is-active')
            }, 1 * 1000);
        }
        popup_newsletter.querySelector('.js-popup-close').addEventListener('click', () => {
            popup_newsletter.classList.remove('is-active');
            Cookies.set('lycia-newsletter-cookie', 'true', { expires: 1 })
        })
        window.html_forms.on('success', () => {
            setTimeout(() => {
                popup_newsletter.classList.remove('is-active')
            }, 3 * 1000);
            Cookies.set('lycia-newsletter-cookie', 'true', { expires: 365 })
        })
    }



}